<template>
  <div class="user-activity">
    <p class="user-activity__content">
      <slot />

      <TimeSince :date="new Date(date)" />

      <span>{{ $t('by') }} {{ user.fullname || $t('deletedUser') }}</span>
    </p>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'UserActivity',

  props: {
    user: {
      type: Object,
      required: true,
    },

    date: {
      type: String,
      required: true,
    },
  },
});
</script>

<style lang="scss">
@use 'settings/colors';
@use 'mixins/typography';

.user-activity {
  display: flex;
  overflow: hidden;
}

.user-activity__content {
  margin: 0;

  @include typography.typography-ellipsis;
}
</style>
